export default __webpack_public_path__ + "static/media/fotoJunto1.a258dfa4.jpg";